
import { memo } from "react";
import { Mode } from "constants/enum";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import InputDateRangePicker from "./InputDateRangePicker";
import PopupDateRangePicker from "./PopupDateRangePicker";

interface Props {
    mode?: Mode;
    width?: any;
    label?: string;
    format?: string;
    disabled?: boolean;
    required?: boolean;
    readOnly?: boolean;
    placeholder?: string;
    isViewPopup?: boolean;
    errorMessage?: string;
    allowChipSuggest?: boolean;
    variant?: "standard" | "outlined";
    value: {
        endDate?: number;
        startDate?: number;
    };
    onChangeValue: (value: { startDate?: number; endDate?: number }) => void;
};

const CustomDateRangePicker = (props: Props): JSX.Element => {
    return (
        props.isViewPopup
            ? <PopupDateRangePicker {...props} />
            : <InputDateRangePicker {...props} />
    );
};

export default memo(CustomDateRangePicker);
